var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/language-picker/full-screen-dialog.ts
import { XDialog } from "@adornis/dialog/x-dialog.js";
import "@adornis/dialog/x-plain-dialog.js";
import { customElement } from "lit/decorators.js";
var FullScreenDialog = class extends XDialog {
  static get element_name() {
    return "full-screen-dialog";
  }
  getOuterWrapper(options) {
    const wrapperElem = super.getOuterWrapper(options);
    wrapperElem.style.setProperty("width", "100vw");
    wrapperElem.style.setProperty("height", "100vh");
    return wrapperElem;
  }
  getInnerWrapper(options) {
    const wrapperElem = super.getInnerWrapper(options);
    wrapperElem.style.setProperty("max-width", "100vmax");
    wrapperElem.style.setProperty("width", "100vw");
    wrapperElem.style.setProperty("height", "100vh");
    return wrapperElem;
  }
  getContentWrapper(options) {
    const wrapperElem = super.getContentWrapper(options);
    wrapperElem.style.setProperty("width", "100vw");
    wrapperElem.style.setProperty("height", "100vh");
    return wrapperElem;
  }
};
FullScreenDialog = __decorateClass([
  customElement("full-screen-dialog")
], FullScreenDialog);
export {
  FullScreenDialog
};
